import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { useCommonWebTranslation } from '../useCommonWebTranslation';
export const LogoutWarningContent = ({ onLoggedOutAcknowledge, onSessionRefresh, onLogoutClick, idleForMs, sessionTimeoutMs, onBeforeSessionExpiredDialogShow, }) => {
    const [idleMs, setIdleMs] = React.useState(idleForMs);
    const [loggedOut, setLoggedOut] = React.useState(idleMs >= sessionTimeoutMs);
    const { t } = useCommonWebTranslation();
    const hasRunningPromise = React.useRef(false);
    React.useEffect(() => {
        if (idleMs >= sessionTimeoutMs && !loggedOut) {
            if (onBeforeSessionExpiredDialogShow && !hasRunningPromise.current) {
                onBeforeSessionExpiredDialogShow()
                    .then(() => {
                    setLoggedOut(true);
                    return;
                })
                    .finally(() => {
                    hasRunningPromise.current = false;
                });
                hasRunningPromise.current = true;
            }
            else if (!onBeforeSessionExpiredDialogShow) {
                setLoggedOut(true);
            }
        }
        else if (idleMs < sessionTimeoutMs && loggedOut) {
            setLoggedOut(false);
        }
    }, [idleMs, sessionTimeoutMs, loggedOut, onBeforeSessionExpiredDialogShow]);
    React.useEffect(() => {
        const handle = setTimeout(() => {
            if (!loggedOut) {
                setIdleMs((prevState) => prevState + 1000);
            }
        }, 1000);
        return () => {
            clearTimeout(handle);
        };
    }, [idleMs, loggedOut]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null,
            React.createElement(React.Fragment, null,
                !loggedOut && t('userIdleMonitor.continueWorking'),
                loggedOut && t('userIdleMonitor.sessionExpired'))),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null,
                React.createElement(React.Fragment, null,
                    !loggedOut && t('userIdleMonitor.doYouWantToContinue', { item: Math.round((sessionTimeoutMs - idleMs) / 1000) }),
                    loggedOut && t('userIdleMonitor.loggedOut')))),
        React.createElement(DialogActions, null,
            !loggedOut && (React.createElement(React.Fragment, null,
                React.createElement(Button, { color: 'primary', onClick: () => {
                        onSessionRefresh();
                    } }, t('userIdleMonitor.continue')),
                React.createElement(Button, { color: 'primary', onClick: () => {
                        onLogoutClick();
                    } }, t('userIdleMonitor.logOut')))),
            loggedOut && (React.createElement(Button, { color: 'primary', onClick: () => onLoggedOutAcknowledge() }, t('userIdleMonitor.ok'))))));
};
